export default class Constants {
  static BasePageSegment = 'account';
  static BasePagePath = `/${Constants.BasePageSegment}`;

  static UsernameFormSegment = 'username/change';
  static UsernameConfirmationSegment = `${Constants.UsernameFormSegment}/confirmation`;

  static UsernameFormPath = `${Constants.BasePagePath}/${Constants.UsernameFormSegment}`;
  static UsernameConfirmationPath = `${Constants.BasePagePath}/${Constants.UsernameFormSegment}/confirmation`;

  static InvalidUsernameFormSegment = 'username/invalid';
  static InvalidUsernameConfirmationSegment = `${Constants.InvalidUsernameFormSegment}/confirmation`;

  static InvalidUsernameFormPath = `${Constants.BasePagePath}/${Constants.InvalidUsernameFormSegment}`;
  static InvalidUsernameConfirmationPath = `${Constants.BasePagePath}/${Constants.InvalidUsernameFormSegment}/confirmation`;

  static SecurityQuestionsFormSegment = 'security-questions/change';
  static SecurityQuestionsConfirmationSegment = `${Constants.SecurityQuestionsFormSegment}/confirmation`;

  static SecurityQuestionsFormPath = `${Constants.BasePagePath}/${Constants.SecurityQuestionsFormSegment}`;
  static SecurityQuestionsConfirmationPath = `${Constants.BasePagePath}/${Constants.SecurityQuestionsConfirmationSegment}`;

  static ChangePasswordFormSegment = 'password/change';
  static ChangePasswordConfirmationSegment = `${Constants.ChangePasswordFormSegment}/confirmation`;

  static ChangePasswordFormPath = `${Constants.BasePagePath}/${Constants.ChangePasswordFormSegment}`;
  static ChangePasswordConfirmationPath = `${Constants.BasePagePath}/${Constants.ChangePasswordConfirmationSegment}`;

  static MfaValidationSegment = 'mfa';
  static MfaValidationPath = `${Constants.BasePagePath}/${Constants.MfaValidationSegment}`;
  static MfaPasswordStepSegment = `${Constants.MfaValidationPath}/password`;
  static MfaInformationsStepSegment = `${Constants.MfaValidationPath}/informations`;
  static MfaEmailStepSegment = `${Constants.MfaValidationPath}/email`;
  static MfaEmailCodeStepSegment = `${Constants.MfaValidationPath}/email-code`;
  static MfaPhoneStepSegment = `${Constants.MfaValidationPath}/phone`;
  static MfaPhoneCodeStepSegment = `${Constants.MfaValidationPath}/phone-code`;
  static MfaConfirmationStepSegment = `${Constants.MfaValidationPath}/confirmation`;
  static MfaProfileController = 'profile';
  static MfaMultifactorController = 'multifactor';
  static MfaCodeLength = 6;
  static MfaMaxAttemptsErrorCode = 'x-4000';
}
